import { useEffect, useState } from 'react';

import { getAbTestV2 } from 'dibs-buyer-layout/exports/clientABTestV2';

export const useAuctionSaleTreatmentVariant = (): boolean | null => {
    const [isAuctionSaleTreatmentVariant, setIsAuctionSaleTreatmentVariant] = useState<
        boolean | null
    >(null);

    useEffect(() => {
        setIsAuctionSaleTreatmentVariant(
            getAbTestV2('auctionSaleTreatment')?.variant === 'variant'
        );
    }, []);

    return isAuctionSaleTreatmentVariant;
};
